module.exports = __webpack_public_path__ + "static/img/xintese.48222b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/xintese.jpg
// module id = 0zSv
// module chunks = 0